<template>
  <v-container fluid class="bill-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Bill</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 2" step="2">Items</v-stepper-step>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">New Bill</p>
                        <v-select
                          class="mb-3"
                          :items=billtype
                          v-model="new_bill.billtype"
                          v-bind:error="error == 'billtype'"
                          v-on:change="clearFields(); clearTransactions()"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the bill type">
                        </v-select>
                        <v-row no-gutters>
                          <v-col cols="12" md="6" class="pr-1 mb-3">
                            <v-menu
                              ref="menu_billdate"
                              v-model="menu_billdate"
                              :close-on-content-click="false"
                              :return-value.sync="new_bill.billdate"
                              transition="scale-transition"
                              offset-y
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  outlined
                                  dense
                                  v-model="new_bill.billdate"
                                  v-on:change="onChangeBillDate($event)"
                                  label="Bill Date"
                                  v-bind="attrs"
                                  v-bind:value="new_bill.billdate"
                                  v-bind:error="error == 'billdate'"
                                  v-on="on"
                                  single-line hint="Bill Date"
                                  persistent-hint
                                  >
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="new_bill.billdate"
                                no-title
                                scrollable
                              >
                                <v-spacer></v-spacer>
                                <v-btn
                                  text
                                  color="primary"
                                  @click="menu_billdate = false"
                                >
                                  Cancel
                                </v-btn>
                                <v-btn
                                  text
                                  color="primary"
                                  @click="onChangeBillDate(new_bill.billdate); $refs.menu_billdate.save(new_bill.billdate)"
                                >
                                  OK
                                </v-btn>
                              </v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="12" md="6" class="pl-1 mb-3">
                            <v-menu
                              ref="menu_billduedate"
                              v-model="menu_billduedate"
                              :close-on-content-click="false"
                              :return-value.sync="new_bill.billduedate"
                              transition="scale-transition"
                              offset-y
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  outlined
                                  dense
                                  v-model="new_bill.billduedate"
                                  label="Due Date"
                                  v-bind="attrs"
                                  v-bind:value="new_bill.billduedate"
                                  v-on="on"
                                  single-line hint="Due Date"
                                  persistent-hint
                                  >
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="new_bill.billduedate"
                                no-title
                                scrollable
                              >
                                <v-spacer></v-spacer>
                                <v-btn
                                  text
                                  color="primary"
                                  @click="menu_billduedate = false"
                                >
                                  Cancel
                                </v-btn>
                                <v-btn
                                  text
                                  color="primary"
                                  @click="$refs.menu_billduedate.save(new_bill.billduedate)"
                                >
                                  OK
                                </v-btn>
                              </v-date-picker>
                            </v-menu>
                          </v-col>
                        </v-row>
                        <v-select
                          class="mb-3"
                          :items="locations.map(x => { return {text: x.locationname, value: x._id} })"
                          v-model="new_bill.locationid"
                          v-bind:error="error == 'locationid'"
                          outlined
                          dense
                          placeholder="Location"
                          persistent-hint
                          single-line hint="Please choose the location">
                        </v-select>
                        <v-select
                          class="mb-3"
                          :items="[{text: 'None', value: null}, ...saleschannels.map(x => {return {text: x.channelname, value: x._id};})]"
                          v-model="new_bill.channelid"
                          v-bind:error="error == 'channelid'"
                          outlined
                          dense
                          placeholder="Channel"
                          persistent-hint
                          single-line hint="Please choose the channel">
                        </v-select>
                      </v-form>
                    </v-col>
                    <v-col v-if="new_bill.billtype=='Expense Bill' || new_bill.billtype=='Invoice Bill'" cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-text-field
                          class="mb-3"
                          placeholder="Vendor Name"
                          single-line hint="Select the Vendor"
                          outlined
                          dense
                          readonly
                          append-icon="mdi-magnify"
                          @click:append="searchVendorDialog"
                          persistent-hint
                          v-model="new_bill.billname"
                          v-bind:error="error == 'vendorid'"
                        >
                        </v-text-field>      
                        <v-textarea
                          v-model="new_bill.billaddress"
                          outlined
                          rows=2
                          label="Address"
                          hint="please enter the vendor address"
                        ></v-textarea>
                        <v-text-field
                          class="mb-3"
                          v-model="new_bill.billphone"
                          outlined
                          dense
                          placeholder="Phone"
                          persistent-hint
                          single-line hint="Enter the phone">
                        </v-text-field>
                        <v-text-field
                          class="mb-3"
                          v-model="new_bill.billmobile"
                          outlined
                          dense
                          placeholder="Mobile"
                          persistent-hint
                          single-line hint="Enter the mobile">
                        </v-text-field>
                      </v-form>
                    </v-col>
                    <v-col v-if="new_bill.billtype=='Expense Bill' || new_bill.billtype=='Invoice Bill'" cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-select
                          class="mb-3"
                          :items="[{text: 'None', value: null}, ...departments.map(x => {return {text: x.departmentname, value: x._id};})]"
                          v-model="new_bill.departmentid"
                          v-bind:error="error == 'departmentid'"
                          outlined
                          dense
                          placeholder="Department"
                          persistent-hint
                          single-line hint="Please choose the department">
                        </v-select>
                        <v-select
                          class="mb-3"
                          :items="[{text: 'None', value: null}, ...vehicles.map(x => {return {text: x.vehiclename, value: x._id};})]"
                          v-model="new_bill.vehicleid"
                          v-bind:error="error == 'vehicleid'"
                          outlined
                          dense
                          placeholder="Vehicle"
                          persistent-hint
                          single-line hint="Please choose the vehicle">
                        </v-select>
                        <v-select
                          class="mb-3"
                          :items=billpayterms
                          v-model="new_bill.billpayterms"
                          v-bind:error="error == 'billpayterms'"
                          outlined
                          dense
                          placeholder="Pay Terms"
                          persistent-hint
                          single-line hint="Please choose the pay terms">
                        </v-select>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-text-field
                          class="mb-3"
                          v-model="new_bill.refnum"
                          v-bind:error="error == 'refnum'"
                          outlined
                          dense
                          placeholder="Ref Num"
                          persistent-hint
                          single-line hint="Enter invoice or ref num">
                        </v-text-field>
                        <v-row no-gutters>
                          <v-col cols="12" md="6" class="mb-3 pr-1">
                            <v-select
                              :items="['USD', 'SGD', 'MMK', 'THB', 'KHR']"
                              v-model="new_bill.primaryCurrency"
                              v-bind:error="error == 'primaryCurrency'"
                              outlined
                              dense
                              placeholder="Currency 1"
                              persistent-hint
                              single-line hint="Currency 1">
                            </v-select>
                          </v-col>
                          <v-col cols="12" md="6" class="pl-1">
                            <v-select
                              :items="['USD', 'SGD', 'MMK', 'THB', 'KHR']"
                              v-model="new_bill.secondaryCurrency"
                              v-bind:error="error == 'secondaryCurrency'"
                              v-bind:value="primaryCurrency"
                              outlined
                              dense
                              placeholder="Currency 2"
                              persistent-hint
                              single-line hint="Currency 2">
                            </v-select>
                          </v-col>
                          <v-col cols="12" md="12">
                            <v-text-field
                              v-model="new_bill.currencyRate"
                              v-bind:error="error == 'currencyRate'"
                              :v-bind:value="1"
                              outlined
                              dense
                              placeholder="Rate"
                              persistent-hint
                              single-line hint="Rate">
                            </v-text-field>
                          </v-col>
                        </v-row>
                        <v-textarea
                          v-model="new_bill.billnote"
                          outlined
                          dense
                          rows=1
                          label="Note"
                          hint="please enter the note"
                        ></v-textarea>
                      </v-form>
                    </v-col>                                        
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="12">
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/bill/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            class="button-shadow"
                            color="primary"
                            @click="checkBill">
                            Next
                          </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
              <v-stepper-content step="2">
                <v-card>
                  <v-row>
                    <v-col md="10">
                      <p class="text-h5">Items</p>
                    </v-col>
                    <v-col md="2" align="right">
                      <v-btn
                        class="button-shadow"
                        color="success"
                        @click="isAddTransaction=true; new_transaction={vehicleid: new_bill.vehicleid}; accountclass='Expense'">
                        Add
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                      <v-col cols="12" sm="12" md="12" lg="12">
                        <v-data-table
                          :headers="header_items"
                          :items="transactions"
                          :items-per-page="500"
                          :footer-props="footer"
                          class="elevation-0"
                        >
                          <template v-slot:item.accountid="{ item }">
                            {{ accounts.length>0 ? accounts.find(account=>account._id == item.accountid)['accountname'] : '' }}
                          </template>
                          <template v-slot:item.vehicleid="{ item }">
                            {{ vehicles.length>0 && vehicles.find(vehicle=>vehicle._id == item.vehicleid)!=null ? vehicles.find(vehicle=>vehicle._id == item.vehicleid)['vehiclename'] : '' }}
                          </template>
                          <template v-slot:item.transdate="{ item }">
                            {{ item.transdate!=null ? new Date(item.transdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) : '' }}
                          </template>
                          <template v-slot:item.actions="{ item }">
                            <v-btn icon color="primary" @click="editTransactionDialog(item)">
                              <v-icon>mdi-pencil-outline</v-icon>
                            </v-btn>
                            <v-btn icon color="primary" @click="deleteTransaction(item)">
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="12">
                      <div class="d-flex justify-center">
                        <v-btn
                          outlined
                          color="primary"
                          @click="step = 1"
                        >
                          Back
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                          v-if="1==0"
                          class="button-shadow"
                          color="primary"
                          @click="step = 3">
                          Next
                        </v-btn>
                        <v-btn
                          v-else
                          :loading="isReceiving"
                          class="button-shadow"
                          color="primary"
                          @click="insertBill()">
                          Save
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>
        </v-stepper>
      </v-col>
    </v-row>
    <div class="text-center">
      <v-dialog
        v-model="isSearchVendor"
        persistent
        scrollable
        width="1000px"
        max-width="1000px"
      >
        <v-card>
          <v-card-title>
            <v-container>
              <v-row>
                <span class="text-h5" style="padding:10px">Search Vendor</span>
              </v-row>

            <v-row>
              <v-col cols="12" md="4">
                <v-form>
                  <v-text-field
                    class="mb-4"
                    v-model="searchvendor.searchtext"
                    outlined
                    dense
                    append-icon="mdi-magnify"
                    @click:append="searchVendor"
                    v-on:keyup.enter="searchVendor"
                    placeholder="Search"
                    persistent-hint
                    single-line hint="Search vendor"
                  >
                  </v-text-field>
                </v-form>
              </v-col>
            </v-row>
            </v-container>

          </v-card-title>
          <v-card-text style="height: 400px;">
            <v-container>
              <v-row>

                <v-col cols="12" md="12">
                  <v-data-table
                    :items-per-page="100"
                    :headers="header_vendors"
                    :items="searches"
                    item-value="name"
                  >
                  <template v-slot:item.vendorimage="{ item }">
                    <img v-if="item.vendorimage" v-bind:src="item.vendorimage" alt="" width="80">
                  </template>
                  <template v-slot:item.vendorname="{ item }">
                    <a class="primaryConst--text">{{ item.vendorname }}</a>
                    <p>{{ item.vendortype }}</p>
                  </template>
                  <template v-slot:item.vendoraddress="{ item }">
                    <a class="primaryConst--text">{{ item.vendoraddress }}</a>
                    <p class="two-line">{{ item.vendorphone  }}</p>
                    <p class="two-line">{{ item.vendormobile  }}</p>
                  </template>
                  <template v-slot:item.townshipid="{ item }">
                    <p class="two-line">{{ item.countryid!=undefined && countries.find(country=>country._id == item.countryid)!=null ? countries.find(country=>country._id == item.countryid)['countryname'] : ''   }}</p>
                    <p class="two-line">{{ item.townshipid!=undefined && townships.find(township=>township._id == item.townshipid)!=null ? townships.find(township=>township._id == item.townshipid)['townshipname'] : ''  }}</p>
                  </template>
                  <template v-slot:item.vendorstatus="{ item }">
                    <v-chip
                      :color="!item.vendorstatus ? 'primaryConst white--text' : 'secondaryConst white--text'"
                      small>
                      {{ item.vendorstatus }}
                    </v-chip>
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <div v-if="item._id!=undefined">
                    <v-btn icon color="primary" @click="selectVendor(item)">
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                    </div>
                  </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isSearchVendor = false"
            >
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="isAddTransaction"
        persistent
        width="1000px"
        max-width="1000px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Add Transaction</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="4">
                  <v-select
                    class="mb-2"
                    :items=data_classes
                    v-model="accountclass"
                    outlined
                    dense
                    placeholder="Class"
                    persistent-hint
                    single-line hint="Please choose the class">
                  </v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    class="mb-2"
                    :items=data_subclasses
                    v-model="accountsubclass"
                    outlined
                    dense
                    placeholder="Subclass"
                    persistent-hint
                    single-line hint="Please choose the subclass">
                  </v-select>
                </v-col>

                <v-col cols="12" md="4">
                  <v-select
                    class="mb-2"
                    :items="accounts.filter(account=>account.accountsubclass==accountsubclass && account.accountsubtype=='Account').map(x => {
                        return {text: x.accountname, value: x._id};
                    })"
                    v-model="new_transaction.accountid"
                    v-on:change="onChangeAccount"
                    v-bind:error="errorindex == 11"
                    outlined
                    dense
                    placeholder="Account"
                    persistent-hint
                    single-line hint="Account">
                  </v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="new_transaction.itemdesc"
                    v-bind:error="errorindex == 12"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Desc"
                    persistent-hint
                    single-line hint="Description">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    type="number"
                    v-model="new_transaction.itemamount"
                    v-bind:error="errorindex == 13"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Amt"
                    persistent-hint
                    single-line hint="Amount">
                  </v-text-field>
                </v-col>
                <v-col v-if="new_transaction.isVehicleExpense==true" cols="12" md="4">
                  <v-select
                    class="mb-2"
                    :items="vehicles.filter(x=>x.locationid==new_bill.locationid).map(x => {
                        return {text: x.vehiclename, value: x._id};
                    })"
                    v-model="new_transaction.vehicleid"
                    v-bind:error="errorindex == 15"
                    outlined
                    dense
                    placeholder="Vehicle"
                    persistent-hint
                    single-line hint="Vehicle">
                  </v-select>
                </v-col>
                <v-col v-if="new_bill.billtype=='Month Expense Bill'" cols="12" md="4">
                  <v-menu
                    ref="menu_transdate"
                    v-model="menu_transdate"
                    :close-on-content-click="false"
                    :return-value.sync="new_transaction.transdate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        outlined
                        dense
                        v-model="new_transaction.transdate"
                        label="Transaction Date"
                        v-bind="attrs"
                        v-bind:value="new_transaction.transdate"
                        v-bind:error="errorindex == 1"
                        v-on="on"
                        persistent-hint
                        single-line hint="Please choose the transaction date">
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="new_transaction.transdate"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="menu_transdate = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu_transdate.save(new_transaction.transdate)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isAddTransaction=false; add_transaction={}"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="addTransaction"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="isEditTransaction"
        persistent
        width="1000px"
        max-width="1000px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Edit Transaction</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="4">
                  <v-select
                    class="mb-2"
                    :items=data_classes
                    v-model="accountclass"
                    outlined
                    dense
                    placeholder="Class"
                    persistent-hint
                    single-line hint="Please choose the class">
                  </v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    class="mb-4"
                    :items=data_subclasses
                    v-model="accountsubclass2"
                    outlined
                    dense
                    placeholder="Subclass"
                    persistent-hint
                    single-line hint="Please choose the subclass">
                  </v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    class="mb-4"
                    :items="accounts.filter(account=>account.accountsubclass==accountsubclass2 && account.accountsubtype=='Account').map(x => {
                        return {text: x.accountname, value: x._id};
                    })"
                    v-model="edit_transaction.accountid"
                    v-on:change="onChangeAccountEdit"
                    outlined
                    dense
                    placeholder="Account"
                    persistent-hint
                    single-line hint="Account">
                  </v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="edit_transaction.itemdesc"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Desc"
                    persistent-hint
                    single-line hint="Description">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    type="number"
                    v-model="edit_transaction.itemamount"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Amt"
                    persistent-hint
                    single-line hint="Amount">
                  </v-text-field>
                </v-col>
                <v-col v-if="edit_transaction.isVehicleExpense==true" cols="12" md="4">
                  <v-select
                    class="mb-2"
                    :items="vehicles.filter(x=>x.locationid==new_bill.locationid).map(x => {
                        return {text: x.vehiclename, value: x._id};
                    })"
                    v-model="edit_transaction.vehicleid"
                    v-bind:error="errorindex == 15"
                    outlined
                    dense
                    placeholder="Vehicle"
                    persistent-hint
                    single-line hint="Vehicle">
                  </v-select>
                </v-col>
                <v-col v-if="new_bill.billtype=='Month Expense Bill'" cols="12" md="4">
                  <v-menu
                    ref="menu_transdate_edit"
                    v-model="menu_transdate_edit"
                    :close-on-content-click="false"
                    :return-value.sync="edit_transaction.transdate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        outlined
                        dense
                        v-model="edit_transaction.transdate"
                        label="Transaction Date"
                        v-bind="attrs"
                        v-bind:value="edit_transaction.transdate"
                        v-bind:error="errorindex == 1"
                        v-on="on"
                        persistent-hint
                        single-line hint="Please choose the transaction date">
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="edit_transaction.transdate"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="menu_transdate_edit = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu_transdate_edit.save(edit_transaction.transdate)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isEditTransaction=false; edit_transaction={}"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="editTransaction"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';
import { getDay15 } from '@/util/tools';

export default {
  data () {
    return {
      header_items: [
        { text: 'Date', value: 'transdate', width: '8%'},
        { text: 'Account', value: 'accountid', width: '20%'},
        { text: 'Vehicle', value: 'vehicleid', width: '15%'},
        { text: 'Description', value: 'itemdesc'},
        { text: 'Amount', value: 'itemamount', width: '10%'},
        { text: 'Actions', value: 'actions', sortable: false, width: '10%' },
      ],
      header_vendors: [
        { text: 'Image', value: 'vendorimage', sortable: false },
        { text: 'Name', value: 'vendorname' },
        { text: 'Address', value: 'vendoraddress' },
        { text: 'Location', value: 'townshipid' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      footer: {'items-per-page-options': [500, 1000, 5000]},
      
      accountclass: null,
      accountsubclass: null,
      accountsubclass2: null,
      isSearchVendor: false,
      step: 1,
      new_bill: {},
      new_transaction: {},
      edit_transaction: {},
      transactions: [],
      searches: [],

      searchvendor: {},
      isAddTransaction: false,
      isEditTransaction: false,
      menu_billdate: false,
      menu_billduedate: false,
      menu_transdate: false,
      menu_transdate_edit: false,
      billtype: ['Expense Bill', 'Invoice Bill', 'Month Expense Bill'],
      billpayterms: ['Due on Receipt', 'Credit 15 Days', 'Credit 30 Days'],
      error: undefined,
      haserror: false,
      errorindex: undefined,
      isDualCurrency: false,
      primaryCurrency: null,
      secondaryCurrency: null,
      currencyRate: null,
      isTaxable: false,
      taxRate: null,
      getDay15: getDay15,
    }
  },
  computed: {
    ...mapState('Account', ['accounts']),
    ...mapState('Bill', ['bills', 'isReceiving']),
    ...mapState('Country', ['countries']),
    ...mapState('Department', ['departments']),
    ...mapState('Location', ['locations']),
    ...mapState('SalesChannel', ['saleschannels']),
    ...mapState('SystemSetting', ['settings']),
    ...mapState('Township', ['townships']),
    ...mapState('User', ['users']),
    ...mapState('Vehicle', ['vehicles']),
    ...mapState('Vendor', ['vendors']),
    data_classes(){
      let filter = this.accounts.filter(account=>account.accountstatus=='New' || account.accountstatus=='Active');
      let object = Object.groupBy(filter, item => {
        return item.accountclass;
      });
      let result = Object.keys(object);
      return [...result];
    },
    data_subclasses(){
      let filter = this.accounts.filter(account=>account.accountclass==this.accountclass);
      let object = Object.groupBy(filter, item => {
        return item.accountsubclass;
      });
      let result = Object.keys(object);
      return [...result, 'Loan Payable'];
    },
  },
  methods: {
    ...mapActions('Account', ['getAccountsRequest']),
    ...mapActions('Bill', ['getBillsRequest', 'insertBillRequest']),
    ...mapActions('Department', ['getDepartmentsRequest']),
    ...mapActions('Location', ['getLocationsRequest']),
    ...mapActions('SalesChannel', ['getSalesChannelsRequest']),
    ...mapActions('Search', ['searchVendorRequest']),
    ...mapActions('SystemSetting', ["getSetting", "getSystemSettingsRequest"]),
    ...mapActions('User', ['getUsersRequest']),
    ...mapActions('Vehicle', ['getVehiclesRequest']),
    ...mapActions('Vendor', ['getVendorsRequest']),
    checkBill(){
      if(!this.new_bill.billtype){
        this.error = 'billtype';
        return false;
      }
      if(!this.new_bill.billdate){
        this.error = 'billdate';
        return false;
      }
      if(!this.new_bill.locationid){
        this.error = 'locationid';
        return false;
      }
      if(!this.new_bill.channelid){
        this.error = 'channelid';
        return false;
      }
      if(this.new_bill.billtype=='Month Expense Bill'){
        this.new_bill.vendorid == null;
        this.new_bill.billaddress = null;
        this.new_bill.billphone = null;
        this.new_bill.billmobile = null;
        this.new_bill.departmentid = null;
        this.new_bill.vehicleid = null;
        this.new_bill.billpayterms = null;
        this.error = null;
        this.step = 2;
        return true;
      }
      if(!this.new_bill.vendorid){
        this.error = 'vendorid';
        return false;
      }
      if(!this.new_bill.departmentid){
        this.error = 'departmentid';
        return false;
      }
      if(!this.new_bill.billpayterms){
        this.error = 'billpayterms';
        return false;
      }
      if(!this.new_bill.refnum){
        this.error = 'refnum';
        return false;
      }
      this.error = null;
      this.step = 2;
      return true;
    },
    checkTransaction(){
      if(!this.new_transaction.accountid){
        this.haserrors = true;
        this.errorindex = 11;
        return false;
      }
      if(!this.new_transaction.itemdesc){
        this.haserrors = true;
        this.errorindex = 12;
        return false;
      }
      if(!this.new_transaction.itemamount){
        this.haserrors = true;
        this.errorindex = 13;
        return false;
      }
      if(this.new_transaction.isVehicleExpense==true && this.new_transaction.vehicleid==null){
        this.haserrors = true;
        this.errorindex = 15;
        return false;
      }
      this.errorindex = -1;
      return true;
    },
    addTransaction(){
      if(this.checkTransaction()==false) return;
      let trans = Object.assign({}, this.new_transaction, {id: Math.floor(Math.random() * Math.pow(10, 10))});
      this.transactions.push(trans);
      this.clearFields();
      this.isAddTransaction = false;
    },
    clearFields(){
      this.new_transaction = {};
    },
    clearTransactions(){
      this.transactions = [];
    },
    async insertBill() {
      if(this.transactions==null || this.transactions.length==0) return;
      let payload = {bill: this.new_bill, transactions: this.transactions};
      await this.insertBillRequest(payload);
      router.push('/bill/list');
    },
    deleteTransaction(item){
      let index = this.transactions.findIndex((trans) => trans.id == item.id);      
      if(index!=-1) this.transactions.splice(index,1);
    },
    insertTransaction(){
      let trans = Object.assign({}, this.transactions_expense, {id: Math.floor(Math.random() * Math.pow(10, 10)),});
      this.transactions.push(trans);
    },
    editTransactionDialog(item){
      let account = this.accounts.find(account=>account._id == item.accountid);
      this.accountclass = account.accountclass;
      this.accountsubclass2 = account.accountsubclass;
      
      this.edit_transaction = Object.assign({}, item);
      this.isEditTransaction = true;
    },
    editTransaction(){
      this.isEditTransaction = false;
      let index = this.transactions.findIndex((trans) => trans.id == this.edit_transaction.id);
      let trans = Object.assign({}, this.edit_transaction);
      this.transactions.splice(index, 1, trans);
      this.edit_transaction = {};
    },
    onChangeAccount(accountid){
      let account = this.accounts.find(x=>x._id==accountid);
      let options = {isVehicleExpense: account.options!=null ? account.options.isVehicleExpense : false}
      if(options.isVehicleExpense!=true) this.new_transaction.vehicleid = null;
      this.new_transaction = Object.assign(this.new_transaction, options);
    },
    onChangeAccountEdit(accountid){
      let account = this.accounts.find(x=>x._id==accountid);
      let options = { isVehicleExpense: account.options!=null ? account.options.isVehicleExpense : false}
      if(options.isVehicleExpense!=true) this.edit_transaction.vehicleid = null;
      this.edit_transaction = Object.assign(this.edit_transaction, options);
    },
    onChangeBillDate(value) {
      let date = new Date(value);
      let end_Date = this.getDay15(date);
      this.new_bill = Object.assign({}, this.new_bill, {billduedate: end_Date});
    },
    searchVendorDialog(){
      this.searchvendor = {};
      this.isSearchVendor = true;
    },
    selectVendor(item){
      this.new_bill.billname = item.vendorname;
      this.new_bill.billaddress = item.vendoraddress;
      this.new_bill.billphone = item.vendorphone;
      this.new_bill.billmobile = item.vendormobile;
      this.new_bill.vendorid = item._id;
      this.isSearchVendor = false;
    },
    async searchVendor(){
      let results = await this.searchVendorRequest(this.searchvendor);
      this.searches = results;
    }
  },

  async created () {
    let params = this.$route.params;
    if(params!=null){
      this.new_bill = Object.assign({}, params);
      delete this.new_bill['billdate'];
      delete this.new_bill['billduedate'];
      delete this.new_bill['billstatus'];
      this.transactions = Object.assign([], params.transactions);
      for(var item of this.transactions){
        item['id'] = item['_id'];
        delete item['_id'];
        delete item['transdate'];
      }
    }
    if(this.accounts.length==0) await this.getAccountsRequest();
    if(this.departments.length==0) await this.getDepartmentsRequest();
    if(this.locations.length==0) await this.getLocationsRequest();
    if(this.saleschannels.length==0) await this.getSalesChannelsRequest();
    if(this.users.length==0) await this.getUsersRequest();
    if(this.vehicles.length==0) await this.getVehiclesRequest();
    if(this.vendors.length==0) await this.getVendorsRequest();


    let currency = await this.getSetting({code: 'CurrencySettings', name: 'PrimaryCurrency'}, );
    let isTaxable = await this.getSetting({code: 'TaxSettings', name: 'isTaxEnabled'}, );
    this.new_bill = Object.assign(this.new_bill, {primaryCurrency: currency, secondaryCurrency: currency, currencyRate: 1, isTaxable: isTaxable});
  }
}
</script>

<style src="./Add.scss" lang="scss"></style>
